import {css} from 'emotion'

export const HeaderMenuStyle = (open) => css({
  '.header-outside': {
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: open ? 'block' : 'none',
  }
})


// WEBPACK FOOTER //
// ./src/styles/partials/layout.js